///////COMPONENTS///////
import { fork } from 'redux-saga/effects'
import login from './login'
import languages from './languages'
import usersManager from './usersManager'
import errorManager from './errorManager'
import rolesManager from './rolesManager'
import tagsManager from './tagsManager'
import kioskPerimeter from './kioskPerimeter'
import account from './account'
import recapStock from './recapStock'
import salesHistoryManager from './salesHistoryManager'
import scheduledPricesManager from './scheduledPricesManager'
import scheduledPromoManager from './scheduledPromoManager'
import pricesManagerByArticle from './pricesManagerByArticle'
import consignation from './consignation'
import kioskPricesManager from './kioskPricesManager'
import logExtranet from './logExtranet'
import logKiosk from './logKiosk'
import logSynchro from './logSynchro'
import logUsers from './logUsers'
import rgpd from './rgpd'
import campaignPrice from './campaignPrice'
import campaignPromo from './campaignPromo'
import telecollectManager from './telecollectManager'
import salesByArticleHistoryManager from './salesByArticleHistoryManager'
import salesHistoryByCodes from './salesHistoryByCodes'
import distributionGroupRepository from './distributionGroupRepository'
import articleManager from './articleManager'
import addItemCatalog from './addItemCatalog'
import companiesManager from './companiesManager'
import translationsManager from './translationsManager'
import exportDatas from './exportDatas'
import userPreferences from './userPreferences'
import notifications from './notifications'
import articleLifeManager from './articleLifeManager'
import initKioskManager from './initKioskManager'
import initKioskCreationDefinition from './initKioskCreationDefinition'
import initKioskCreationBankDetails from './initKioskCreationBankDetails'
import initKioskCreationAddItems from './initKioskCreationAddItems'
import initKioskCreationAddPrices from './initKioskCreationAddPrices'
import initKioskImplantation from './initKioskImplantation'
import initKioskCreationSummary from './initKioskCreationSummary'
import marketing from './marketing'
import kioskProductionList from './kioskProductionList'
import kioskDiagnostic from './kioskDiagnostic'
import itemCatalogDetail from './itemCatalogDetail'
import itemCatalog from './itemCatalog'
import kioskEditSetup from './kioskEditSetup'
import kioskRacksRequest from './kioskRacksRequest'
import kioskEditImplantation from './kioskEditImplantation'
import languagesManager from './languagesManager'
import table from './table'
import salesControl from './salesControl'
import statistics from './statistics'

const sagas = function* () {
	yield fork(login)
	yield fork(languages)
	yield fork(usersManager)
	yield fork(errorManager)
	yield fork(rolesManager)
	yield fork(tagsManager)
	yield fork(account)
	yield fork(kioskPerimeter)
	yield fork(recapStock)
	yield fork(salesHistoryManager)
	yield fork(consignation)
	yield fork(scheduledPricesManager)
	yield fork(scheduledPromoManager)
	yield fork(pricesManagerByArticle)
	yield fork(kioskPricesManager)
	yield fork(logExtranet)
	yield fork(logKiosk)
	yield fork(logSynchro)
	yield fork(logUsers)
	yield fork(rgpd)
	yield fork(campaignPrice)
	yield fork(campaignPromo)
	yield fork(telecollectManager)
	yield fork(salesByArticleHistoryManager)
	yield fork(salesHistoryByCodes)
	yield fork(distributionGroupRepository)
	yield fork(articleManager)
	yield fork(addItemCatalog)
	yield fork(companiesManager)
	yield fork(translationsManager)
	yield fork(exportDatas)
	yield fork(userPreferences)
	yield fork(notifications)
	yield fork(articleLifeManager)
	yield fork(initKioskManager)
	yield fork(initKioskCreationDefinition)
	yield fork(initKioskCreationBankDetails)
	yield fork(initKioskCreationAddItems)
	yield fork(initKioskCreationAddPrices)
	yield fork(initKioskImplantation)
	yield fork(initKioskCreationSummary)
	yield fork(marketing)
	yield fork(kioskProductionList)
	yield fork(kioskDiagnostic)
	yield fork(itemCatalogDetail)
	yield fork(itemCatalog)
	yield fork(kioskEditSetup)
	yield fork(kioskRacksRequest)
	yield fork(kioskEditImplantation)
	yield fork(languagesManager)
	yield fork(table)
	yield fork(salesControl)
	yield fork(statistics)
}

export default sagas
